/*
 * The feature id decides three things at once, so a new entry here is never enough on its own:
 *  - the entry the project config has to list in `feedbackFeatures` for the prompt to happen,
 *  - the Firestore collection the entries are written to (feedback-<project>/<puzzle>/<id>),
 *  - the translation group PUZZLE.feedback_modal.feature.<id>, which the modal builds all of
 *    its labels from. Without those keys the modal shows the raw key names.
 */
export enum FeedbackFeatureEnum {
  General = 'general',
  Leaderboard = 'leaderboard',
  WordGuess = 'word-guess',
}
